<template>
    <div>
        <div style="width: 100%;height: 8vw;display: flex;background-color: #050a30;">
            
            <div style="display: flex;width: 10%;height: 100%;justify-content: center;align-items: center;margin-left: 10%;">
                <a href="https://globaltherapy.co" style="display: inline-block;height: 60%;width: 55%;">
                    <img style="height: 100%;width: 100%;" src="@/assets/logo.png"/>
                </a>
  
            </div>
            <div style="display: flex;width: 10%;height: 100%;justify-content: center;align-items: center;margin-left: 60%;">
                          <a href="https://globaltherapy.co" style="display: inline-block;height: 40%;width: 35%;">
                              <img style="height: 100%;width: 100%;" src="@/assets/ff.png"/>
                          </a>
            
            </div>
        </div>
        <div style="width: 100%;height: 20vw;display: flex;justify-content: center;align-items: center;">
            <div style="display: flex;width: 70%;height: 40%;align-items: center;justify-content: center;">
                <el-input style="width: 30%;" class="custom-input" v-model="input" placeholder="IN PUT CODE"></el-input>
                <el-button style="margin-left: 5%;" class="custom-button" @click="verifyProduct">VERIFY</el-button>
            </div>
        </div>
        <!-- <div style="width: 100%;height: 40vw;display: flex;flex-direction: column;">
            <div style="width: 100%;height: 20%;align-items: center;display: flex;margin-left: 20%;font-size: 1.4vw;font-weight: 600;">Miracle White packaging through the years</div>
            <el-carousel :interval="4000" type="card" height="28vw ">
              <el-carousel-item v-for="(item, index) in arraye" :key="index" style="">
  
                   <a href="http://www.veniscy.com/#/processing-center" style="display: inline-block;">
                      <img v-bind:src="item.url" style="width: 100%;height: 100%;">
                   </a>
  
              </el-carousel-item>
             </el-carousel>
             
        </div> -->
      
      <div id="carousel" class="carousel">
      
             <div id='iten_1' class="hideLeft">
              <img src="@/assets/1.jpg">
            </div>
  
      
            <div id='item_2' class="prevLeftSecond">
              <img src="@/assets/2.jpg">
            </div>
      
            <div id='item_3' class="prev">
              <img src="@/assets/3.jpg">
            </div>
      
            <div id='item_4' class="selected">
              <img src="@/assets/4.jpg">
            </div>
      
            <div id='item_5' class="next">
              <img src="@/assets/5.jpg">
            </div>
      
            <div id='item_6' class="nextRightSecond">
              <img src="@/assets/6.jpg">
            </div>
      
            <div id='item_7' class="hideRight">
              <img src="@/assets/7.jpg">
            </div>
      
            <div id='item_8' class="hideRight">
              <img src="@/assets/8.jpg">
            </div>
            <div id='item_9' class="hideRight">
              <img src="@/assets/9.jpg">
            </div>
            
           
      
          </div>
      
          <div class="buttons">
            <button id="prev">Prev</button>
            <button id="next">Next</button>
          </div>
              
      
      
        <div style="width: 100%;height: 5vw;justify-content: center;align-items: center;display: flex;margin-bottom: 5vw"><div style="font-size: 3vw;padding: 1%;border-radius: 1%;font-weight: 700;">VERIFY YOUR GOODS</div>  </div>
        
        
        <div style="display: flex;width: 100%;height: 20vw;background-color: #050a30;color: #ffffff;flex-direction: column;">
            <div style="display: flex;width: 100%;height: 70%;">
                <div style="display: flex;width:70% ;height: 100%;align-items: flex-start;flex-direction: column;justify-content: center;margin-left: 5%;">
                    <div style="height: 25%;font-size: 1.5vw;">Contacto</div>
                    <div style="font-size: 1.3vw;">Correo electr6nico: global.therapyens@gmail.com</div>
                </div>
                <div style="display: flex;width:30% ;height: 100%;flex-direction: column;">
                    <div style="display: flex;height: 40%;width: 100%;flex-direction: column;justify-content: flex-end;margin-bottom: 5%;font-size: 1.5vw;">Horas De Trabajo</div>
                    <div style="display: flex;height: 60%;width: 100%;">
                        <div style="display: flex;flex-direction: column;width: 40%;height: 100%;align-items: flex-start;font-size: 1.3vw;">
                            <div>Lun- Vie</div>
                            <div>Sabado-</div>
                            <div>Dom</div>
                        </div>
                        <div style="display: flex;flex-direction: column;width: 40%;height: 100%;align-items: flex-end;font-size: 1.3vw;">
                            <div>9:00 am - 5:00 pm</div>
                            <div>Cerrado</div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div style="display: flex;width: 90%;height: 30%;font-size: 1.3vw;margin-left: 5%;flex-direction: column;justify-content: center;">
                <el-divider></el-divider>
                C 2024GLOBALTHERAPY</div>
        </div>
    </div>
    
    
  </template>
  
  <script>
  
  
  export default {
  data() {
    return {
      input: '',
    }
  },
  methods: {
    verifyProduct() {
      const inputValue = this.input.trim();
      if (!inputValue) {
        this.$message.warning('Please enter the content');
        return;
      }
      fetch('/verify_code', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: inputValue })
      })
      .then(response => response.json())
      .then(data => {
        // 根据后端返回的状态显示不同的消息
        if (data.status === 'verified') {
          // 防伪码验证成功
          this.$message.success('Your product is genuine. Thank you for verifying!');
        } else if (data.status === 'invalid') {
          // 防伪码无效
          this.$message.error('You may have a fake product. Please contact us.');
        } else if (data.status === 'already verified') {
          // 防伪码已被验证
          this.$message.warning(`This code was already verified on ${data.first_verified_at}. Please contact us if you have any questions.`);
        } else {
          // 其他情况，可能是服务器返回了未预料的状态
          this.$message.error('An unexpected error occurred. Please try again later.');
        }
      })
      .catch(error => {
        console.error('Error verifying product:', error);
        this.$message.error('An error occurred. Please try again later.');
      });
    }
  },

    mounted() {
        
      const $ = str => document.querySelector(str);
      const $$ = str => document.querySelectorAll(str);
      
      (function() {
          if (!window.app) {
              window.app = {};
          }
          app.carousel = {
              removeClass: function(el, classname='') {
                  if (el) {
                      if (classname === '') {
                          el.className = '';
                      } else {
                          el.classList.remove(classname);
                      }
                      return el;
                  }
                  return;
              },
              reorder: function() {
                  let childcnt = $("#carousel").children.length;
                  let childs = $("#carousel").children;
      
                  for (let j=0; j< childcnt; j++) {
                      childs[j].dataset.pos = j;
                  }
              },
              move: function(el) {
                  let selected = el;
      
                  if (typeof el === "string") {
                  console.log(`got string: ${el}`);
                      selected = (el == "next") ? $(".selected").nextElementSibling : $(".selected").previousElementSibling;
                      console.dir(selected);
                  }
      
                  let curpos = parseInt(app.selected.dataset.pos);
                  let tgtpos = parseInt(selected.dataset.pos);
      
                  let cnt = curpos - tgtpos;
                  let dir = (cnt < 0) ? -1 : 1;
                  let shift = Math.abs(cnt);
      
                  for (let i=0; i<shift; i++) {
                      let el = (dir == -1) ? $("#carousel").firstElementChild : $("#carousel").lastElementChild;
      
                      if (dir == -1) {
                          el.dataset.pos = $("#carousel").children.length;
                          $('#carousel').append(el);
                      } else {
                          el.dataset.pos = 0;
                          $('#carousel').prepend(el);
                      }
      
                      app.carousel.reorder();
                  }
      
      
                  app.selected = selected;
                  let next = selected.nextElementSibling;// ? selected.nextElementSibling : selected.parentElement.firstElementChild;
                  var prev = selected.previousElementSibling; // ? selected.previousElementSibling : selected.parentElement.lastElementChild;
                  var prevSecond = prev ? prev.previousElementSibling : selected.parentElement.lastElementChild;
                  var nextSecond = next ? next.nextElementSibling : selected.parentElement.firstElementChild;
      
                  selected.className = '';
                  selected.classList.add("selected");
      
                  app.carousel.removeClass(prev).classList.add('prev');
                  app.carousel.removeClass(next).classList.add('next');
      
                  app.carousel.removeClass(nextSecond).classList.add("nextRightSecond");
                  app.carousel.removeClass(prevSecond).classList.add("prevLeftSecond");
      
                  app.carousel.nextAll(nextSecond).forEach(item=>{ item.className = ''; item.classList.add('hideRight') });
                  app.carousel.prevAll(prevSecond).forEach(item=>{ item.className = ''; item.classList.add('hideLeft') });
      
              },
              nextAll: function(el) {
                  let els = [];
      
                  if (el) {
                      while (el = el.nextElementSibling) { els.push(el); }
                  }
      
                  return els;
      
              },
              prevAll: function(el) {
                  let els = [];
      
                  if (el) {
                      while (el = el.previousElementSibling) { els.push(el); }
                  }
      
      
                  return els;
              },
              keypress: function(e) {
                  switch (e.which) {
                      case 37: // left
                          app.carousel.move('prev');
                          break;
      
                      case 39: // right
                          app.carousel.move('next');
                          break;
      
                      default:
                          return;
                  }
                  e.preventDefault();
                  return false;
              },
              select: function(e) {
              console.log(`select: ${e}`);
                  let tgt = e.target;
                  while (!tgt.parentElement.classList.contains('carousel')) {
                      tgt = tgt.parentElement;
                  }
      
                  app.carousel.move(tgt);
      
              },
              previous: function(e) {
                  app.carousel.move('prev');
              },
              next: function(e) {
                  app.carousel.move('next');
              },
              doDown: function(e) {
              console.log(`down: ${e.x}`);
                  app.carousel.state.downX = e.x;
              },
              doUp: function(e) {
              console.log(`up: ${e.x}`);
                  let direction = 0,
                      velocity = 0;
      
                  if (app.carousel.state.downX) {
                      direction = (app.carousel.state.downX > e.x) ? -1 : 1;
                      velocity = app.carousel.state.downX - e.x;
      
                      if (Math.abs(app.carousel.state.downX - e.x) < 10) {
                          app.carousel.select(e);
                          return false;
                      }
                      if (direction === -1) {
                          app.carousel.move('next');
                      } else {
                          app.carousel.move('prev');
                      }
                      app.carousel.state.downX = 0;
                  }
              },
              init: function() {
                  document.addEventListener("keydown", app.carousel.keypress);
                 // $('#carousel').addEventListener("click", app.carousel.select, true);
                  $("#carousel").addEventListener("mousedown", app.carousel.doDown);
                  $("#carousel").addEventListener("touchstart", app.carousel.doDown);
                  $("#carousel").addEventListener("mouseup", app.carousel.doUp);
                  $("#carousel").addEventListener("touchend", app.carousel.doup);
      
                  app.carousel.reorder();
                  $('#prev').addEventListener("click", app.carousel.previous);
                  $('#next').addEventListener("click", app.carousel.next);
                  app.selected = $(".selected");
      
              },
              state: {}
      
          }
          app.carousel.init();
      })();
    },
  }
  </script>
  
  <style>
  
  #carousel {
    position: relative;
    height: 500px;
    top: 50%;
  
    overflow: hidden;
  }
  #carousel div {
    position: absolute;
    transition: transform 400ms, left 400ms, opacity 400ms, z-index 0s;
    opacity: 1;
  }
  #carousel div img {
    width: 400px;
    transition: width 400ms;
     -webkit-user-drag: none;
  }
  #carousel div.hideLeft {
    left: 0%;
    opacity: 0;
    transform: translateY(50%) translateX(-50%);
  }
  #carousel div.hideLeft img {
    width: 200px;
  }
  #carousel div.hideRight {
    left: 100%;
    opacity: 0;
    transform: translateY(50%) translateX(-50%);
  }
  #carousel div.hideRight img {
    width: 200px;
  }
  #carousel div.prev {
    z-index: 5;
    left: 30%;
    transform: translateY(50px) translateX(-50%);
  }
  #carousel img:hover {
    cursor: 
  }
  #carousel div.prev img {
    width: 300px;
  }
  #carousel div.prevLeftSecond {
    z-index: 4;
    left: 15%;
    transform: translateY(50%) translateX(-50%);
    opacity: 0.7;
  }
  #carousel div.prevLeftSecond img {
    width: 200px;
  }
  #carousel div.selected {
    z-index: 10;
    left: 50%;
    transform: translateY(0px) translateX(-50%);
  }
  #carousel div.next {
    z-index: 5;
    left: 70%;
    transform: translateY(50px) translateX(-50%);
  }
  #carousel div.next img {
    width: 300px;
  }
  #carousel div.nextRightSecond {
    z-index: 4;
    left: 85%;
    transform: translateY(50%) translateX(-50%);
    opacity: 0.7;
  }
  #carousel div.nextRightSecond img {
    width: 200px;
  }
  
  .buttons {
      display: none;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 10px;
  }
  .custom-input input::placeholder {
    text-align: center; /* 将 placeholder 文本居中显示 */
  }
  
  .custom-input input {
    transition: transform 0.3s, box-shadow 0.3s, background-color 0.3s;
    background-image: linear-gradient(to right top, #007fff, #5a73ff, #007fff, #6fa9ff);
    color: white; /* 将字体颜色设置为白色 */
  }
  
  .custom-input input:hover,
  .custom-input input:active {
    background: linear-gradient(#e6e6fa, #bb8fe2); /* 渐变到边框时的过渡效果 */
  }
  
  .custom-input:hover,
  .custom-input:active {
    transform: scale(1.05);
    box-shadow: 0 0 10px rgba(147, 112, 219, 0.5);
  }
  
  .custom-button {
    transition: transform 0.3s, box-shadow 0.3s, background-color 0.3s;
    background-image: linear-gradient(to right top, #007fff, #5a73ff, #007fff, #6fa9ff);
    color: white; /* 将字体颜色设置为白色 */
  }
  
  .custom-button:hover {
    transform: scale(1.05);
    box-shadow: 0 0 10px rgba(147, 112, 219, 0.5);
    background-color: #e6e6fa; /* 悬停时的背景色 - 浅紫色 */
  }
  
  .custom-button:active {
    transform: scale(0.95);
    box-shadow: 0 0 10px rgba(147, 112, 219, 0.8);
    background-color: #d8bfd8; /* 点击时的背景色 - 较深的紫色 */
  }
  </style>
  